export default __webpack_public_path__ + "static/media/fossil-example.f798d6a2.png";